<div [formGroup]="form">
  <div class="flex flex-column gap-2 mb-3">
    <label for="label" class="font-semibold w-full">{{ "role_management.form.label" | translate }}*</label>
    <input
      pInputText
      [readOnly]="actionType === 'edit' || requestStarted()"
      id="label"
      formControlName="label"
      autocomplete="off"
    />
  </div>
  <div class="flex flex-column gap-2 mb-3">
    <label for="description" class="font-semibold w-full">{{ "role_management.form.description" | translate }}*</label>
    <input pInputText id="description" formControlName="description" autocomplete="off" [readOnly]="requestStarted()" />
  </div>
</div>

@if (permissionsMatrix()) {
  <h3 id="accessPermissionsTitle" class="m-0 mb-3 text-primary text-sm font-normal">
    {{ "role_management.form.access_permissions" | translate }}
  </h3>

  <p-table
    class="permissionsMatrix mb-3 transparent"
    [value]="permissionsMatrix() ?? []"
    [columns]="columns()"
    [scrollable]="true"
    scrollHeight="400px"
  >
    <ng-template #header let-columns>
      <tr>
        @for (col of columns; track col) {
          <th class="font-size-sm font-normal" [ngClass]="{ 'text-center': col.field !== 'name' }">
            {{ "role_management.form." + col.header | translate }}
          </th>
        }
      </tr>
    </ng-template>

    <ng-template #body let-rowData let-tableColumns="columns">
      <tr>
        @for (col of tableColumns; track col) {
          <td [ngClass]="{ 'text-center': col.field !== 'name' }">
            @switch (col.field) {
              @case ("name") {
                {{ "role_management.form." + rowData[col.field] | translate }}
              }
              @case ("read") {
                @if (rowData.read) {
                  <p-checkbox [(ngModel)]="rowData.read.match" [binary]="true" [disabled]="requestStarted()" />
                }
              }
              @case ("create") {
                @if (rowData.create) {
                  <p-checkbox [(ngModel)]="rowData.create.match" [binary]="true" [disabled]="requestStarted()" />
                }
              }
              @case ("update") {
                @if (rowData.update) {
                  <p-checkbox [(ngModel)]="rowData.update.match" [binary]="true" [disabled]="requestStarted()" />
                }
              }
              @case ("delete") {
                @if (rowData.delete) {
                  <p-checkbox [(ngModel)]="rowData.delete.match" [binary]="true" [disabled]="requestStarted()" />
                }
              }
              @case ("export") {
                @if (rowData.export) {
                  <p-checkbox [(ngModel)]="rowData.export.match" [binary]="true" [disabled]="requestStarted()" />
                }
              }
              @case ("import") {
                @if (rowData.import) {
                  <p-checkbox [(ngModel)]="rowData.import.match" [binary]="true" />
                }
              }
            }
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
}
@if (notificationPermissions().length > 0) {
  <app-notification-permissions [permissions]="notificationPermissions()" [disabled]="requestStarted()" />
}
<div class="flex justify-content-end gap-2 dialogBtnGroup mb-3">
  <app-button
    buttonText="Speichern"
    [disabled]="form.invalid || requestStarted()"
    (click)="saveRole()"
    [loading]="requestStarted()"
  ></app-button>
</div>
